import { useMemo } from "react";
import { useAuth } from "./auth";
import { decodeAccessToken, type AccessClaims } from "./jwt";

/**
 * Reactive access-token claims (role, tenantId, userId, email). Derived from the
 * stored token so it stays correct across login, silent refresh, and reload — no
 * duplicated state. UI-only; the server still authorizes every request.
 */
export function useClaims(): AccessClaims {
  const token = useAuth((s) => s.token);
  return useMemo(() => decodeAccessToken(token), [token]);
}
